import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { PageHeader } from '../../components/PageHeader';
import { useSession } from '../../stores/session';

const SETTINGS_NAV = [
  { to: '/users', label: 'ผู้ใช้', ownerOnly: true },
  { to: '/branches', label: 'สาขา', ownerOnly: true },
  { to: '/payment-methods', label: 'การชำระเงิน' },
  { to: '/promotions', label: 'โปรโมชั่น' },
  { to: '/audit', label: 'ประวัติ' },
  { to: '/settings', label: 'ระบบ', ownerOnly: true },
] as const;

type StatusTone = 'ok' | 'warn' | 'danger' | 'neutral';

export function SettingsHeader({
  title,
  subtitle,
  actions,
  status,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: StatusTone };
}) {
  const user = useSession((state) => state.user);
  const items = SETTINGS_NAV.filter(
    (item) =>
      !('ownerOnly' in item) || !item.ownerOnly || user?.role === 'owner',
  );

  return (
    <div className="mb-6">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={actions}
        status={status}
      />
      <nav
        aria-label="เมนูศูนย์การตั้งค่า"
        className="flex flex-wrap gap-1 border-b border-line"
      >
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `min-h-11 shrink-0 border-b-2 px-3 py-2 text-center text-sm-label font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink ${
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-ink-2 hover:bg-bg-warm hover:text-ink'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
